/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../api/httpService";
import { encryptString, decryptString } from "../utils/helpers/functions";
import auth from "../utils/helpers/auth";

export const login = createAsyncThunk(
	"auth/login",
	// eslint-disable-next-line consistent-return
	async (payload, { rejectWithValue }) => {
		try {
			const response = await axios.post("/api/admin/secureReports", payload);
			// localStorage.setItem(TOKENKEY, response.data.data.accessToken);
			auth.setAccessCode(encryptString(payload.accessCode));

			return { ...response.data, accessCode: payload.accessCode };
		} catch (error) {
			if (error.response) {
				return rejectWithValue(error.response.data.message);
			}
			if (error.request) {
				return rejectWithValue("Network Error");
			}
			if (error.message) {
				return rejectWithValue(error.message);
			}
		}
	}
);

const authSlice = createSlice({
	name: "auth",
	initialState: {
		isAuthenticated: false,
		isProcessing: false,
		isLoggingOut: false,
		user: {},
		role: "",
		region: {
			name: "Nigeria",
			region: "NG",
			region_logo: "https://doc.smartdeals.com.ng/files/region/NG/region.jpg",
			iso_name: "NGA",
			list: 1,
		},
		message: "",
		error: "",
		bizFrom: "SMARTDEALS",
	},
	reducers: {
		logout(state, action) {
			state.isProcessing = false;
			state.isLoggingOut = false;
			state.isAuthenticated = false;
			state.user = {};
			localStorage.clear();
			window.location = "/";
		},
		loginSuccess(state, action) {
			state.isProcessing = false;
			state.isAuthenticated = !!decryptString(action.payload.accessCode);
			state.user = {
				...action.payload,
				accessCode: decryptString(action.payload.accessCode),
			};
			state.message = "";
			state.error = "";
			state.message = action.payload.message;
			// state.region.region = action.payload.region || "NG";
			// state.region.region_logo =
			// 	action.payload.region_logo ||
			// 	"https://doc.smartdeals.com.ng/files/region/NG/region.jpg";
		},
		setRegion(state, action) {
			state.region.name = action.payload.name;
			state.region.region = action.payload.short_name || action.payload.region;
			state.region.short_name =
				action.payload.short_name || action.payload.region;
			state.region.region_logo =
				action.payload.region_logo || action.payload.logo;
			state.region.iso_name = action.payload.iso_name;
			state.region.list = action.payload.list;
		},
		setBizfrom(state, action) {
			state.bizFrom = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(login.pending, (state, action) => {
				state.isProcessing = true;
				state.error = null;
			})
			.addCase(login.fulfilled, (state, action) => {
				state.isProcessing = false;
				state.isAuthenticated = !!action.payload.accessCode;
				state.error = null;
				state.user = action.payload.data;
				state.message = action.payload.message;
			})
			.addCase(login.rejected, (state, action) => {
				state.isProcessing = false;
				state.error = action.payload;
			});
	},
});

export const { logout, loginSuccess, setRegion, setBizfrom } =
	authSlice.actions;

export default authSlice.reducer;
